import { createComplement, listComplements, getComplement, updateComplement, deleteComplement } from '../lib/db/complements'
import { ApiResponse } from './hostings'

export class ComplementsAPI {
    static async create(data: any): Promise<ApiResponse> {
        const result = await createComplement(data)
        return { success: true, data: result.data }
    }
    static async list(): Promise<ApiResponse> {
        const result = await listComplements()
        return { success: true, data: result.data }
    }
    static async get(id: string): Promise<ApiResponse> {
        const result = await getComplement(id)
        return { success: true, data: result.data }
    }
    static async update(id: string, data: any): Promise<ApiResponse> {
        const result = await updateComplement(id, data)
        return { success: true, data: result.data }
    }
    static async delete(id: string): Promise<ApiResponse> {
        const result = await deleteComplement(id)
        return { success: true, data: result.data }
    }
}
